const withImages = (editor) => {
  const { isVoid } = editor;
  
  editor.isVoid = (element) => {
    return element.type === "image" || isVoid(element);
  };
  
  return editor;
};
  

export default withImages;